module.exports = __webpack_public_path__ + "static/media/educationalArticle.169b4f33.png";